import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
/** Warm hairline divider from the Specra surface system. */ export const SpecraDivider = /*#__PURE__*/ React.forwardRef(({ className, orientation = 'horizontal', ...props }, ref)=>/*#__PURE__*/ _jsx("hr", {
        "aria-orientation": orientation,
        className: cn('shrink-0 border-0 bg-border', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className),
        ref: ref,
        ...props
    }));
SpecraDivider.displayName = 'SpecraDivider';
